export default "__VITE_ASSET__CsCQ6B44__"